<template>
<!-- <div v-show="(isHover || isVisible || searchText)" @mouseover="isHover = true" @mouseout="isHover = false"> -->
<div class="map-object-search">
  <el-select v-model="searchType" class="search-type-input" placeholder="Select" size="medium" style="width:100px" @change="onSearchTypeChange">
    <el-option label="일반장비" value="quick"></el-option>
    <el-option label="연결장비" value="connection"></el-option>
    <el-option label="인터페이스" value="interface"></el-option>
  </el-select>
  <el-autocomplete
    ref="searchInput"
    class="search-text-input"
    :popper-class="`map-object-search-popper ${searchType}`"
    :placeholder="setPlaceholder"
    v-model="searchText"
    :fetch-suggestions="querySearchAsync"
    :trigger-on-focus="false"
    :popper-append-to-body="false"
    size="medium"
    @blur="onBlur"
    @select="onSelect">
    <span class="el-input__icon" style="pointer-events: none;" slot="suffix">
      <i class="el-input__icon el-icon-search" style="margin-right:4px;"></i>
    </span>
    <template slot-scope="{ item }">
      <template v-if="searchType==='quick'">
        <div v-if="item.empty === true" style="text-align: center;">
          검색 결과가 없습니다.
        </div>
        <div v-else>
          <div class="main-name">
            <span class="right-name">{{ item.objtypeName || '-' }}</span>
            <span class="left-name">{{ item.objName || item.ipaddress || '-' }}</span>
          </div>
          <div class="sub-name">
            <span class="left-name">{{ item.ipaddress || '-' }}</span>
          </div>
        </div>
      </template>
      <template v-else-if="searchType==='interface'">
        <div v-if="item.empty === true" style="text-align: center;">
          검색 결과가 없습니다.
        </div>
        <div v-else>
          <div class="main-name">
            <span class="right-name">{{ item.objName || item.ipaddress || '-' }}</span>
            <span class="left-name">{{ getInterfaceLabel(item) || '-' }}</span>
          </div>
          <div class="sub-name">
            <span class="right-name">{{ item.ipaddress || '-' }}</span>
            <span class="left-name">{{ item.interfaceIp || '-' }}</span>
          </div>
        </div>
      </template>
      <template v-else>
        <div v-if="item.empty === true" style="text-align: center;">
          검색 결과가 없습니다.
        </div>
        <div v-else>
          <div class="main-name">
            <span class="right-name">{{ item.hostName || '-' }}</span>
            <span class="left-name">{{ item.objName || item.objIpaddress || '-' }}</span>
          </div>
          <div class="sub-name">
            <span class="right-name">{{ item.hostIpaddress || '-' }}</span>
            <span class="left-name">{{ item.objIpaddress || '-' }}</span>
          </div>
          <div class="sub2-name">
            <span class="left-name">{{ item.objMacaddress || '-' }}</span>
          </div>
        </div>
      </template>
    </template>
  </el-autocomplete>
  <el-dialog title="이동할 맵 선택" :visible.sync="mapListVisible" @opened="opened" @closed="closed" width="400px" :append-to-body="true" margin-top="30vh">
    <el-table :data="mapList" @cell-click="onMapSelect" height="300" style="width: 100%;" row-class-name="map-list-table-row" :show-overflow-tooltip="true" border>
      <el-table-column align="center" property="label" label="맵 이름"></el-table-column>
    </el-table>
  </el-dialog>
</div>
</template>

<script>
import { find, isEmpty, assign, forEach } from 'lodash';

import MapAPI from '@/api/topologymap/common';
import MapConst from '@/constants/topologymap';
import { MapInfo, MapUtil } from '@/views/topologymap/js/maps';
import Base from '@/mixins/topologymap/base';

export default {
  name: 'WMapObjectSearch',
  mixins: [Base],
  data() {
    return {
      mapListVisible: false,
      mapList: [],
      searchText: '',
      isHover: false,
      isVisible: false,
      searchType: 'quick', // quick, connection, interface
    };
  },
  computed: {
    isEmptyValue() {
      return this.searchText === undefined || this.searchText === null || this.searchText === '';
    },
    isShow() {
      return this.isHover || this.isVisible || this.searchText;
    },
    setPlaceholder() {
      let placeholderLabel = '장비명, IP, MAC 검색'; // 기본 설정: connection

      if (this.searchType === 'quick') {
        placeholderLabel = '장비명, IP 검색';
      } else if (this.searchType === 'interface') {
        placeholderLabel = 'IP 검색';
      }

      return placeholderLabel;
    },
  },
  watch: {
    currentMapId() {
      this.$refs.searchInput.$refs.input.clear();
    },
    isShow(value) {
      if (value === false) {
        this.$refs.searchInput.$refs.input.clear();
      }
    },
  },
  mounted() {
    const layout = document.querySelector('.graph-area');
    if (layout) {
      layout.addEventListener('mousemove', this.onMouseMove);
    }
  },
  beforeDestroy() {
    const layout = document.querySelector('.graph-area');
    if (layout) {
      layout.removeEventListener('mousemove', this.onMouseMove);
    }
  },
  methods: {
    /**
     * 비동기 검색
     * @author {name}
     * @param  {[type]}   queryString [description]
     * @param  {Function} cb          [description]
     * @return {[type]}               [description]
     */
    querySearchAsync(queryString, cb) {
      if (this.isEmptyValue) {
        cb([]);
      } else {
        MapAPI.getSearchObject2(queryString, this.searchType).then((response) => {
          const result = response.data;

          if (result.success && !isEmpty(result.data)) {
            cb(result.data);
          } else {
            cb([{
              empty: true,
            }]);
          }
        });
      }
    },
    /**
     * 검색 된 결과 선택
     * @author {name}
     * @param  {[type]} item [description]
     * @return {[type]}      [description]
     */
    onSelect(item) {
      if (this.searchType === 'quick' || this.searchType === 'interface') {
        if (item.isObj) {
          if (!item.objId) {
            return;
          }
          MapAPI.getMaplistByObjId(item.objId).then((response) => {
            const mapList = response.data.data;
            this.gotoTarget({
              objId: item.objId,
            }, mapList);
          });
        } else if (item.isAutomapDevice) {
          if (!item.ipaddress) {
            return;
          }
          MapAPI.getMaplistByAutomapDevice(item.ipaddress).then((response) => {
            const mapList = response.data.data;
            this.gotoTarget({
              ipaddress: item.ipaddress,
            }, mapList);
          });
        }
      } else if (this.searchType === 'connection') {
        MapAPI.getMaplistByAutomapDevice(item.hostIpaddress).then((response) => {
          const mapList = response.data.data;
          this.gotoTarget({
            connectInfoParam: {
              ipaddress: item.objIpaddress,
              macaddress: item.objMacaddress,
            },
            ipaddress: item.hostIpaddress,
          }, mapList);
        });
      }
    },
    /**
     * 선택 된 장비로 이동
     * @author {name}
     * @param  {[type]}  item               [description]
     * @param  {[type]}  mapList            [description]
     * @return {[type]}                     [description]
     */
    gotoTarget(param, mapList) {
      if (mapList) {
        const findMap = find(mapList, ['mapId', this.currentMapId]);
        if (findMap) { // 맵 목록 중 현재 맵이 존재한다.
          MapInfo.getInstance(this).getCanvas(MapConst.VIEW_MODE.MONITORING).initSelect(MapInfo.getInstance(this).getGraph(), param);
        } else if (mapList.length === 1) { // 맵이 한 개이므로 바로 라우팅한다.
          this.routeMap(mapList[0].mapId, {
            redirect: false,
            ...param,
          });
        } else { // 맵이 여러개이므로 선택 할 수 있는 팝업창을 띄운다.
          forEach(mapList, (map) => {
            assign(map, param);
          });
          this.mapList = mapList;
          this.mapListVisible = true;
        }
      }
    },
    /**
     * 맵 리스트 팝업 Open after
     * @author {name}
     * @return {[type]} [description]
     */
    opened() {
    },
    /**
     * 맵 리스트 팝업 Close after
     * @author {name}
     * @return {[type]} [description]
     */
    closed() {
      this.mapList = [];
    },
    /**
     * 맵 리스트 팝업에서 맵 선택
     * @author {name}
     * @param  {[type]} map [description]
     * @return {[type]}     [description]
     */
    onMapSelect(map) {
      this.routeMap(map.mapId, {
        redirect: false,
        ...map,
      });
      this.mapListVisible = false;
    },
    showControl() {
      if (window.objectSearchVisibleTimeout) {
        clearTimeout(window.objectSearchVisibleTimeout);
      }
      this.isVisible = true;
      window.objectSearchVisibleTimeout = setTimeout(() => {
        this.isVisible = false;
      }, 5000);
    },
    onMouseMove() {
      this.showControl();
    },
    /**
     * 검색 컴포넌트에서 포커싱 잃으면 검색리스트 숨김처리
     * @author {name}
     * @return {[type]} [description]
     */
    onBlur() {
      setTimeout(() => {
        this.$refs.searchInput.close();
      }, 300);
    },
    /**
     * 검색구분 변경
     * @author {name}
     * @return {[type]} [description]
     */
    onSearchTypeChange() {
      this.$refs.searchInput.suggestions = [];
      this.searchText = '';
    },
    /**
     * 인터페이스 이름 우선순위로 표현
     * @author JH
     * @return {item} [Interface]
     */
    getInterfaceLabel(item) {
      return MapUtil.getInterfaceLabel(item.netInterfaceAlias, item.netInterfaceName, item.netInterfaceDeviceName);
    },
  },
};
</script>

<style lang="scss">
.map-object-search-popper {
  width: 350px !important;

  &.connection {
    &.el-autocomplete-suggestion li {
      & > div {
        height: 45px;
      }
    }
  }

  &.el-autocomplete-suggestion li {

    & > div {
      height: 30px;
      margin: 10px 0px;

      .right-name {
        float: right;
        font-size: 11px;
      }

      .main-name {
        font-size: 13px;
        line-height: 15px;
        vertical-align: bottom;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #333;

        .left-name {
        }
        .right-name {
          color: #888;
        }
      }

      .sub-name {
        line-height: 20px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        .left-name {
          font-size: 12px;
          color: #767676;
        }
        .right-name {
          color: #bababa;
        }
      }

      .sub2-name {
        line-height: 10px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        .left-name {
          font-size: 11px;
          color: #999;
        }
      }
    }
  }
}
.map-object-search {
  position: absolute;
  top: 10px;
  left: 10px;

  input {
    box-shadow: rgba(0, 0, 0, 0.15) 0px 1px 2px 0px;
    border: 1px solid rgba(0, 0, 0, 0.15);
    transition: width .3s;
  }

  .search-text-input {
    input {
      width: 150px;
      &:focus {
        width: 200px;
      }
    }
  }
}
.map-list-table-row {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/monitoring/MapObjectSearch.vue